import { _Locale } from "./supportedLocale";

export type FormatCurrencyAmountArgs = {
  value: unknown;
  locale?: _Locale;
  currency?: string;
  numDecimals: number;
};

/**
 * Format number to currency locale string.
 */
export const formatCurrencyAmount = ({
  value,
  locale = "en-US",
  numDecimals,
  currency = "USD",
}: FormatCurrencyAmountArgs) => {
  const num = Number(value);
  // Fallback to string value.
  if (isNaN(num)) return String(value);
  return num.toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: numDecimals,
    maximumFractionDigits: numDecimals,
  });
};
